<div class="d-flex flex-row row-cols-2 gap-2 fs-9 fw-semibold">
  <div class="col-12 g-2">
    @if(config.label){
    <span class="col-12"
      >{{ config.label.key | translate }}:<strong class="text-tertiary">{{
        config.required ? "*" : ""
      }}</strong></span
    >
    } @if(config.inputType == 'textbox'){
    <input
      [type]="config.type"
      [value]="textInputControl.value || ''"
      [formControl]="textInputControl"
      class="form-control fs-9 form-control-lg"
      [placeholder]="config.placeholder.key | translate"
    />
    } @else if (config.inputType == 'textarea') {
    <textarea
      [value]="textInputControl.value || ''"
      [formControl]="textInputControl"
      rows="4"
      class="form-control fs-9"
      [placeholder]="config.placeholder.key | translate"
    ></textarea>
    }
  </div>
</div>
